/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { TemplateRef } from '@angular/core';
import { UrlTree } from '@angular/router';

export class NavLink {
  constructor(public name: string,
              public templateRef: TemplateRef<any>,
              public url: Maybe<UrlTree>,
              public useByDefault: boolean,
              public visible: boolean) {

  }
}
